/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeDiscountBean', 'model/StripePlanBean', 'model/StripeSubscriptionItemBean', 'model/StripeTaxRateBean', 'model/SubscriptionMetadataBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeDiscountBean'), require('./StripePlanBean'), require('./StripeSubscriptionItemBean'), require('./StripeTaxRateBean'), require('./SubscriptionMetadataBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeSubscriptionRequest = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.StripeDiscountBean, root.BpmbuildProductionappspotcom.StripePlanBean, root.BpmbuildProductionappspotcom.StripeSubscriptionItemBean, root.BpmbuildProductionappspotcom.StripeTaxRateBean, root.BpmbuildProductionappspotcom.SubscriptionMetadataBean);
  }
}(this, function(ApiClient, StripeDiscountBean, StripePlanBean, StripeSubscriptionItemBean, StripeTaxRateBean, SubscriptionMetadataBean) {
  'use strict';

  /**
   * The StripeSubscriptionRequest model module.
   * @module model/StripeSubscriptionRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionRequest</code>.
   * @alias module:model/StripeSubscriptionRequest
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionRequest} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionRequest} The populated <code>StripeSubscriptionRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('billingThresholdsAmount'))
        obj.billingThresholdsAmount = ApiClient.convertToType(data['billingThresholdsAmount'], 'String');
      if (data.hasOwnProperty('collection_method'))
        obj.collectionMethod = ApiClient.convertToType(data['collection_method'], 'String');
      if (data.hasOwnProperty('start'))
        obj.start = ApiClient.convertToType(data['start'], 'Date');
      if (data.hasOwnProperty('ended_at'))
        obj.endedAt = ApiClient.convertToType(data['ended_at'], 'String');
      if (data.hasOwnProperty('customer'))
        obj.customer = ApiClient.convertToType(data['customer'], 'String');
      if (data.hasOwnProperty('livemode'))
        obj.livemode = ApiClient.convertToType(data['livemode'], 'Boolean');
      if (data.hasOwnProperty('stripeSubscriptionId'))
        obj.stripeSubscriptionId = ApiClient.convertToType(data['stripeSubscriptionId'], 'String');
      if (data.hasOwnProperty('metadata'))
        obj.metadata = SubscriptionMetadataBean.constructFromObject(data['metadata']);
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('trial_start'))
        obj.trialStart = ApiClient.convertToType(data['trial_start'], 'Date');
      if (data.hasOwnProperty('plan'))
        obj.plan = StripePlanBean.constructFromObject(data['plan']);
      if (data.hasOwnProperty('current_period_end'))
        obj.currentPeriodEnd = ApiClient.convertToType(data['current_period_end'], 'Date');
      if (data.hasOwnProperty('cancel_at_period_end'))
        obj.cancelAtPeriodEnd = ApiClient.convertToType(data['cancel_at_period_end'], 'Boolean');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('billing_cycle_anchor'))
        obj.billingCycleAnchor = ApiClient.convertToType(data['billing_cycle_anchor'], 'Date');
      if (data.hasOwnProperty('items.data'))
        obj.itemsData = ApiClient.convertToType(data['items.data'], [StripeSubscriptionItemBean]);
      if (data.hasOwnProperty('default_tax_rates'))
        obj.defaultTaxRates = ApiClient.convertToType(data['default_tax_rates'], [StripeTaxRateBean]);
      if (data.hasOwnProperty('start_date'))
        obj.startDate = ApiClient.convertToType(data['start_date'], 'Date');
      if (data.hasOwnProperty('default_payment_method'))
        obj.defaultPaymentMethod = ApiClient.convertToType(data['default_payment_method'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('days_unit_due'))
        obj.daysUnitDue = ApiClient.convertToType(data['days_unit_due'], 'Number');
      if (data.hasOwnProperty('default_source'))
        obj.defaultSource = ApiClient.convertToType(data['default_source'], 'String');
      if (data.hasOwnProperty('object'))
        obj._object = ApiClient.convertToType(data['object'], 'String');
      if (data.hasOwnProperty('billingThresholdsResetBillingCycleAnchor'))
        obj.billingThresholdsResetBillingCycleAnchor = ApiClient.convertToType(data['billingThresholdsResetBillingCycleAnchor'], 'Boolean');
      if (data.hasOwnProperty('canceled_at'))
        obj.canceledAt = ApiClient.convertToType(data['canceled_at'], 'Date');
      if (data.hasOwnProperty('quantity'))
        obj.quantity = ApiClient.convertToType(data['quantity'], 'String');
      if (data.hasOwnProperty('current_period_start'))
        obj.currentPeriodStart = ApiClient.convertToType(data['current_period_start'], 'Date');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('applicationFeePercent'))
        obj.applicationFeePercent = ApiClient.convertToType(data['applicationFeePercent'], 'String');
      if (data.hasOwnProperty('latest_invoice'))
        obj.latestInvoice = ApiClient.convertToType(data['latest_invoice'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('discount'))
        obj.discount = StripeDiscountBean.constructFromObject(data['discount']);
      if (data.hasOwnProperty('trial_end'))
        obj.trialEnd = ApiClient.convertToType(data['trial_end'], 'Date');
    }
    return obj;
  }

  /**
   * @member {String} billingThresholdsAmount
   */
  exports.prototype.billingThresholdsAmount = undefined;

  /**
   * @member {String} collectionMethod
   */
  exports.prototype.collectionMethod = undefined;

  /**
   * @member {Date} start
   */
  exports.prototype.start = undefined;

  /**
   * @member {String} endedAt
   */
  exports.prototype.endedAt = undefined;

  /**
   * @member {String} customer
   */
  exports.prototype.customer = undefined;

  /**
   * @member {Boolean} livemode
   */
  exports.prototype.livemode = undefined;

  /**
   * @member {String} stripeSubscriptionId
   */
  exports.prototype.stripeSubscriptionId = undefined;

  /**
   * @member {module:model/SubscriptionMetadataBean} metadata
   */
  exports.prototype.metadata = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Date} trialStart
   */
  exports.prototype.trialStart = undefined;

  /**
   * @member {module:model/StripePlanBean} plan
   */
  exports.prototype.plan = undefined;

  /**
   * @member {Date} currentPeriodEnd
   */
  exports.prototype.currentPeriodEnd = undefined;

  /**
   * @member {Boolean} cancelAtPeriodEnd
   */
  exports.prototype.cancelAtPeriodEnd = undefined;

  /**
   * @member {String} status
   */
  exports.prototype.status = undefined;

  /**
   * @member {Date} billingCycleAnchor
   */
  exports.prototype.billingCycleAnchor = undefined;

  /**
   * @member {Array.<module:model/StripeSubscriptionItemBean>} itemsData
   */
  exports.prototype.itemsData = undefined;

  /**
   * @member {Array.<module:model/StripeTaxRateBean>} defaultTaxRates
   */
  exports.prototype.defaultTaxRates = undefined;

  /**
   * @member {Date} startDate
   */
  exports.prototype.startDate = undefined;

  /**
   * @member {String} defaultPaymentMethod
   */
  exports.prototype.defaultPaymentMethod = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Number} daysUnitDue
   */
  exports.prototype.daysUnitDue = undefined;

  /**
   * @member {String} defaultSource
   */
  exports.prototype.defaultSource = undefined;

  /**
   * @member {String} _object
   */
  exports.prototype._object = undefined;

  /**
   * @member {Boolean} billingThresholdsResetBillingCycleAnchor
   */
  exports.prototype.billingThresholdsResetBillingCycleAnchor = undefined;

  /**
   * @member {Date} canceledAt
   */
  exports.prototype.canceledAt = undefined;

  /**
   * @member {String} quantity
   */
  exports.prototype.quantity = undefined;

  /**
   * @member {Date} currentPeriodStart
   */
  exports.prototype.currentPeriodStart = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} applicationFeePercent
   */
  exports.prototype.applicationFeePercent = undefined;

  /**
   * @member {String} latestInvoice
   */
  exports.prototype.latestInvoice = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {module:model/StripeDiscountBean} discount
   */
  exports.prototype.discount = undefined;

  /**
   * @member {Date} trialEnd
   */
  exports.prototype.trialEnd = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeSubscriptionRequest.js